/* Shopify owns cart contents, prices, discounts and currency. */
(() => {
  'use strict';
  const root = window.linxCommerce?.root;
  if (!root) return;
  let busy = false;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const url = path => root + path;
  const money = (amount, currency) => new Intl.NumberFormat('en-CA', {style:'currency', currency, currencyDisplay:'code'}).format(amount / 100);
  async function request(path, body) {
    const response = await fetch(url(path), {
      method: body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store',
      headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
      ...(body ? {body:JSON.stringify(body)} : {})
    });
    let data;
    try { data = await response.json(); } catch { throw Error('The cart could not load. Please try again.'); }
    if (!response.ok) throw Error(typeof data.description === 'string' ? data.description : 'Shopify could not update your cart. Please try again.');
    return data;
  }
  function count(cart) {
    document.querySelectorAll('.cart-link__bubble').forEach(el => {
      el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      el.textContent = cart.item_count || '';
    });
    document.querySelectorAll('.js-drawer-open-cart').forEach(el => el.setAttribute('aria-label', `Cart, ${cart.item_count} items`));
  }
  function modal() {
    const dialog = document.querySelector('#preview-dialog');
    const content = document.querySelector('#dialog-content');
    dialog.classList.remove('original-quick-dialog');
    dialog.setAttribute('aria-labelledby','linx-cart-title');
    if (!dialog.open) dialog.showModal();
    return content;
  }
  function render(cart, message = '') {
    count(cart);
    const content = modal();
    content.innerHTML = `<section data-native-money><h2 id="linx-cart-title">Your cart</h2><p role="status" class="linx-cart-status">${esc(message)}</p>${cart.items.length ? cart.items.map(item => `<div class="cart-row"><div><strong>${esc(item.product_title)}</strong>${item.variant_title ? `<br>${esc(item.variant_title)}` : ''}<p>${esc(money(item.final_line_price, cart.currency))}</p><label>Quantity <input type="number" min="0" step="1" value="${item.quantity}" data-cart-key="${esc(item.key)}" aria-label="Quantity for ${esc(item.title)}" style="width:5em"></label></div><button type="button" data-cart-remove="${esc(item.key)}" aria-label="Remove ${esc(item.title)}">Remove</button></div>`).join('') : '<p>Your cart is empty. Explore our growing supplies to get started.</p>'}${cart.items.length ? `<p><strong>Subtotal: ${esc(money(cart.total_price,cart.currency))}</strong></p>${cart.total_discount ? `<p>Savings: ${esc(money(cart.total_discount,cart.currency))}</p>` : ''}<p>Cart amounts are in ${esc(cart.currency)}. Shipping, taxes and any applicable duties are calculated at checkout.</p><p>Organic fertilizers ship within Canada only. Available shipping options depend on your delivery address and every item in your cart.</p><form method="post" action="${esc(url('cart'))}" data-shopify-commerce><button class="btn" type="submit" name="checkout">Checkout</button></form>` : ''}<p><a href="${esc(url('cart'))}">View cart page</a></p></section>`;
    content.querySelectorAll('[data-cart-key]').forEach(input => input.addEventListener('change', () => {
      const quantity = Number(input.value);
      if (!Number.isSafeInteger(quantity) || quantity < 0) { render(cart,'Enter a whole quantity of zero or more.'); return; }
      change(input.dataset.cartKey,quantity);
    }));
    content.querySelectorAll('[data-cart-remove]').forEach(button => button.addEventListener('click', () => change(button.dataset.cartRemove,0)));
  }
  function lock() {
    document.querySelectorAll('#dialog-content [data-native-money] input, #dialog-content [data-native-money] button').forEach(el => el.disabled = busy);
  }
  async function show() {
    if (busy) return;
    busy = true;
    modal().innerHTML = '<h2 id="linx-cart-title">Your cart</h2><p role="status">Loading your cart…</p>';
    try { render(await request('cart.js')); }
    catch (error) { modal().innerHTML = `<h2 id="linx-cart-title">Your cart</h2><p role="alert">${esc(error.message)}</p><a class="btn" href="${esc(url('cart'))}">Open cart page</a>`; }
    finally { busy = false; lock(); }
  }
  async function change(key, quantity) {
    if (busy) return;
    busy = true; lock();
    try { render(await request('cart/change.js',{id:key,quantity})); }
    catch (error) {
      try { render(await request('cart.js'),error.message); }
      catch { modal().innerHTML = `<h2 id="linx-cart-title">Your cart</h2><p role="alert">${esc(error.message)}</p><a href="${esc(url('cart'))}">Reload cart</a>`; }
    } finally { busy = false; lock(); }
  }
  async function add(id, quantity) {
    if (busy) throw Error('Your cart is updating. Please wait.');
    if (!/^\d+$/.test(String(id)) || !Number.isSafeInteger(quantity) || quantity < 1) throw Error('Choose a valid size and whole quantity.');
    busy = true; lock();
    try {
      await request('cart/add.js',{items:[{id,quantity}]});
      try { render(await request('cart.js')); }
      catch { window.location.assign(url('cart')); }
    } catch (error) {
      // Stock can change even on a 422. Re-read; never retry an add automatically.
      try { count(await request('cart.js')); } catch {}
      throw error;
    } finally { busy = false; lock(); }
  }
  // The live theme replaces this legacy modal implementation with linx-cart-drawer.js.
  if (!window.linxCart) window.linxCart = {show,add};
  document.addEventListener('click', event => {
    if (!event.target.closest('.js-drawer-open-cart')) return;
    event.preventDefault(); event.stopImmediatePropagation(); show();
  }, true);
  request('cart.js').then(count).catch(() => {});
})();
